module.exports = __webpack_public_path__ + "static/media/progress-winning-chapters.3a10637d.svg";